export default "__VITE_ASSET__PVyWSa6S__"